var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_vm._v(" ")])],1),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_vm._t("default")],2)],1),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_vm._v(" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }